import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps } from '@mui/material'
import { ReactNode, useMemo, useRef } from 'react'

type IOvSelectOption = Record<string, string | number | null | any>

export type IOvSelect = SelectProps & {
  options: IOvSelectOption[]
  label: string
  key?: any
  helperText?: string
  labelKey: string
  valueKey: string
  size?: SelectProps['size']
  readOnly?: boolean
  withEmpty?: boolean
  emptyLabel?: string
  output?: 'option' | 'value'
  renderOption?: (value: IOvSelectOption) => void
  sx?: SelectProps['sx']
}

export const OvSelect = ({
  options,
  label,
  withEmpty,
  emptyLabel,
  error,
  helperText = '',
  key,
  value,
  valueKey,
  size,
  labelKey,
  output = 'value',
  readOnly,
  renderOption,
  sx,
  ...rest
}: IOvSelect) => {
  const element = useRef<ReactNode>(null)
  const generateInputLabel = useMemo(() => `select_${label}-${Math.random()}`, [label])

  const generateSelectId = useMemo(() => `select_${label}-component-${Math.random()}`, [])

  const readOnlyProps = useMemo(() => ({ readOnly }), [readOnly])

  return (
    <FormControl
      variant="outlined"
      error={error}
      size={size}
      sx={{ minWidth: { md: 130 }, width: '100%', ...sx }}>
      <InputLabel id={generateInputLabel}>{label}</InputLabel>
      <Select
        ref={element}
        sx={sx}
        MenuProps={{
          disablePortal: true,
        }}
        disabled={!options || options.length === 0}
        key={key}
        labelId={generateInputLabel}
        id={generateSelectId}
        value={value}
        inputProps={readOnlyProps}
        label={label}
        {...rest}>
        {withEmpty && emptyLabel && <MenuItem value={null as any}>{emptyLabel}</MenuItem>}
        {options &&
          options.map(singleOption => (
            <MenuItem
              key={singleOption[valueKey]}
              value={output === 'value' ? singleOption[valueKey] : singleOption}>
              {renderOption ? renderOption(singleOption) : singleOption[labelKey]}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}
